module.exports = __webpack_public_path__ + "img/01-2首页.20255502.png";